 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/bookdescription'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import DEDICATION from '@/components/dedication'
 import PROLOGUE from '@/components/prologue'
 import PART001 from '@/components/part001'
 import PART001CHAPTER0700HOURSINTOTHELIGHT from '@/components/part001chapter0700hoursintothelight'
 import PART001CHAPTER0800HOURSCONSULT from '@/components/part001chapter0800hoursconsult'
 import PART001CHAPTER0900HOURSWEIRDFRIENDS from '@/components/part001chapter0900hoursweirdfriends'
 import PART001CHAPTER1000HOURSSTARCHILD from '@/components/part001chapter1000hoursstarchild'
 import PART001CHAPTER1100HOURSURGENTCARE from '@/components/part001chapter1100hoursurgentcare'
 import PART001CHAPTER1200HOURSHIGHNOON from '@/components/part001chapter1200hourshighnoon'
 import PART002 from '@/components/part002'
 import PART002CHAPTER1300HOURSTHEEMISSARY from '@/components/part002chapter1300hourstheemissary'
 import PART002CHAPTER1400HOURSCHECKIN from '@/components/part002chapter1400hourscheckin'
 import PART002CHAPTER1500HOURSYETANOTHERWEIRDFRIEND from '@/components/part002chapter1500hoursyetanotherweirdfriend'
 import PART002CHAPTER1600HOURSCULTCLASSIC from '@/components/part002chapter1600hourscultclassic'
 import PART002CHAPTER1700HOURSBOILERPLATE from '@/components/part002chapter1700hoursboilerplate'
 import PART002CHAPTER1800HOURSNUCLEAROPTION from '@/components/part002chapter1800hoursnuclearoption'
 import PART003 from '@/components/part003'
 import PART003CHAPTER1900HOURSLOGISTICS from '@/components/part003chapter1900hourslogistics'
 import PART003CHAPTER2000HOURSHORSDECOMBAT from '@/components/part003chapter2000hourshorsdecombat'
 import PART003CHAPTER2100HOURSSURPRISEPACKAGES from '@/components/part003chapter2100hourssurprisepackages'
 import PART003CHAPTER2200HOURSRAMPUP from '@/components/part003chapter2200hoursrampup'
 import PART003CHAPTER2300HOURSBACKINTHEGAME from '@/components/part003chapter2300hoursbackinthegame'
 import PART003CHAPTER2400HOURSMIDNIGHT from '@/components/part003chapter2400hoursmidnight'
 import PART004 from '@/components/part004'
 import LOVE_2 from '@/components/love_2'
 import PART004CHAPTER0200HOURSICORINTHIANS1551 from '@/components/part004chapter0200hoursicorinthians1551'
 import PART004CHAPTER0300HOURSTHESHEPHERD from '@/components/part004chapter0300hourstheshepherd'
 import PART004CHAPTER0400HOURSMEACULPA from '@/components/part004chapter0400hoursmeaculpa'
 import PART004CHAPTER0500HOURSCOMELETUSREASONTOGETHER from '@/components/part004chapter0500hourscomeletusreasontogether'
 import PART004CHAPTER0600HOURSTHEENDOFALLTHINGS from '@/components/part004chapter0600hourstheendofallthings'
 import PART004CHAPTER0700HOURSDAWNSEARLYLIGHT from '@/components/part004chapter0700hoursdawnsearlylight'
 import EPILOGUE from '@/components/epilogue'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import AFTERWORD from '@/components/afterword'
 import THEOTHERAFTERWORDKAYLIESGIFTS from '@/components/theotherafterwordkayliesgifts'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import IFYOULIKED from '@/components/ifyouliked'
 import OTHERWORDFIREPRESSTITLESBYBILLDESMEDT from '@/components/otherwordfirepresstitlesbybilldesmedt'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/bookdescription",
 			"name" : "bookdescription",
 			"component" : BOOKDESCRIPTION
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/prologue",
 			"name" : "prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/part001",
 			"name" : "part001",
 			"component" : PART001
 		},
 		{
 			"path" : "/part001chapter0700hoursintothelight",
 			"name" : "part001chapter0700hoursintothelight",
 			"component" : PART001CHAPTER0700HOURSINTOTHELIGHT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js